<template>
    <nav>
        <ul class="pager">
            <li :class="{'disabled': !hasPreviousPage}">
                <a href="#" @click.prevent="previous">
                    <i class="fa fa-angle-double-left"></i> Previous
                </a>
            </li>

            <li :class="{'disabled': !hasNextPage}">
                <a href="#" @click.prevent="next">
                    Next <i class="fa fa-angle-double-right"></i>
                </a>
            </li>
        </ul>
    </nav>
</template>

<style>
    .pager-page {
        display: inline-block;
        padding: 5px 14px;
        background-color: #337ab7;
        color: #ffffff;
        border-radius: 15px;
    }
</style>

<script>
    import moment from 'moment'

    export default {
        props: ['previousId', 'nextId'],

        computed: {
            hasPreviousPage() {
                return this.previousId !== null
            },

            hasNextPage() {
                return this.nextId !== null
            }
        },

        methods: {
            previous() {
                if (this.hasPreviousPage) {
                    this.$emit('navigate', this.previousId)
                }
            },

            next() {
                if (this.hasNextPage) {
                    this.$emit('navigate', this.nextId)
                }
            }
        }
    }
</script>
